// components/common/knowledgeLevel.ts

export type KnowledgeLevel = "beginner" | "intermediate" | "advanced";

export const KNOWLEDGE_LEVEL_STORAGE_KEY = "userKnowledgeLevel";
export const KNOWLEDGE_LEVELS: readonly KnowledgeLevel[] = [
  "beginner",
  "intermediate",
  "advanced",
];

export function parseKnowledgeLevel(
  raw: string | null,
  fallback: KnowledgeLevel = "beginner",
): KnowledgeLevel {
  if (raw && (KNOWLEDGE_LEVELS as readonly string[]).includes(raw)) {
    return raw as KnowledgeLevel;
  }
  return fallback;
}
